// True only on the live RM site (https://rm.kanchaneshver.com) — used to
// gate features that should stay off on devrm.kanchaneshver.com and any
// other non-live host (localhost, preview builds, etc).
const LIVE_RM_HOSTNAME = "rm.kanchaneshver.com";

export const isProdHost = () => {
  try {
    return window.location.hostname === LIVE_RM_HOSTNAME;
  } catch (e) {
    return false;
  }
};
